import * as React from 'react';
import {Query} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SalesAutomationStepTemplate as SalesAutomationStepTemplateFragment,
    StepTemplatesForStageQuery as StepTemplatesForStageQueryQuery,
    StepTemplatesForStageQueryVariables as StepTemplatesForStageQueryQueryVariables,
} from 'nutshell-graphql-types';

import {STEP_TEMPLATES} from '../../constants';
import GET_STEP_TEMPLATES_FOR_STAGE from '../../graphql/queries/get-step-templates-for-stage.graphql';

import {StepTemplateCard} from '../cards/step-template-card';

import {CardsContainer} from './cards-container';

type OwnProps = {
    parentId: string;
    hideCards: boolean;
    isCardBeingDragged: boolean;
    isCardDragDisabled: boolean;
};

type GraphQLProps = {
    isLoadingStepTemplates: boolean;
    errorMessage: string | null | undefined;
    stepTemplates: SalesAutomationStepTemplateFragment[];
};

type Props = OwnProps & GraphQLProps;

export class StageCardsStepTemplatesContainerComponent extends React.PureComponent<Props> {
    render() {
        // Disable dragging while fetching step template data, and also while
        // performing a move mutation, which sets this.props.isCardDragDisabled to true
        const isDragDisabled = this.props.isLoadingStepTemplates || this.props.isCardDragDisabled;

        const cards = this.props.stepTemplates.map((stepTemplate, index) => {
            return (
                <StepTemplateCard
                    key={stepTemplate.id}
                    index={index}
                    isHidden={this.props.hideCards}
                    isDragDisabled={isDragDisabled}
                    stepTemplate={stepTemplate}
                />
            );
        });

        return (
            <CardsContainer
                type={STEP_TEMPLATES}
                isLoading={this.props.isLoadingStepTemplates}
                errorMessage={this.props.errorMessage}
                isCardBeingDragged={this.props.isCardBeingDragged}
                parentId={this.props.parentId}
                hideAddCard={this.props.hideCards}
            >
                {cards}
            </CardsContainer>
        );
    }
}

class StepTemplateQuery extends Query<
    StepTemplatesForStageQueryQuery,
    StepTemplatesForStageQueryQueryVariables
> {}

export const StageCardsStepTemplatesContainer = (props: OwnProps) => (
    <StepTemplateQuery query={GET_STEP_TEMPLATES_FOR_STAGE} variables={{stageId: props.parentId}}>
        {({data, loading, error}) => {
            const editableStepTemplates = data ? data.editableStepTemplates : null;

            return (
                <StageCardsStepTemplatesContainerComponent
                    {...props}
                    isLoadingStepTemplates={loading}
                    // @ts-expect-error
                    errorMessage={safelyGetGraphQLErrorMessage(error)}
                    stepTemplates={editableStepTemplates || []}
                />
            );
        }}
    </StepTemplateQuery>
);
